import React from 'react';
import styled, { css } from 'styled-components';

const ImageContainer = styled.div<{image:string}>`
    position: fixed;
    left: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 100%;

    background-size: cover;
    background-position: center center;

    ${({image}) => css`
        background-image: url(${image});
    `}
`

interface IImageBackgroundProps {
    src: string,
}

const ImageBackground : React.FC<IImageBackgroundProps> = ({ src }) => {

    return (
        <ImageContainer image={ src } />
    )

}

export default ImageBackground;